import {
  useGetFlightPurchase,
  useCreateFlightPurchase,
} from 'api-hooks/order/ticket-order';
import { TicketSaleModel } from 'api-hooks/sale/ticket-sale';
import { KIND, Notification } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import LoadingComponent from 'components/common/loading';
import ErrorViewComponent from 'components/elements/error-view-component';
import FetchWrapperComponent from 'components/elements/fetch-wrapper-component';
import useApprovalableEdit from 'hooks/use-approvalable-edit';
import { DetailContainer, SeparatorVertical } from 'legacy-modules/styles';
import { useRouter } from 'next/router';
import * as React from 'react';
import { NavigationProps } from 'types';

import FlightPurchaseForm from './components/form';
import { TicketOrderFormType } from './components/form-type';

export type FlightPurchaseViewParams = {
  id: string;
  flightSale?: TicketSaleModel;
  defaultValues?: TicketOrderFormType;
};

export default function FlightPurchaseView(
  props: NavigationProps<NavigationRoutes.FlightPurchasesView>,
) {
  const { query } = useRouter();
  const id = query?.id as string;
  const { data, error, isLoading, isFetching, refetch } = useGetFlightPurchase({
    id,
  });

  const { mutateAsync, error: errorMutate } = useCreateFlightPurchase();

  const flightPurchase = data?.data;
  const onResolve = useApprovalableEdit('flight-purchases');

  return (
    <FetchWrapperComponent
      onRetry={refetch}
      loadingComponent={<LoadingComponent />}
      error={error}
      errorComponent={
        <DetailContainer>
          <ErrorViewComponent refetch={refetch} />
        </DetailContainer>
      }
      isLoading={isLoading || isFetching}
      component={
        <>
          <FlightPurchaseForm
            {...props}
            renderError={
              !!errorMutate &&
              !!errorMutate.message && (
                <>
                  <Notification
                    overrides={{
                      Body: {
                        style: { width: 'auto', wordBreak: 'break-all' },
                      },
                    }}
                    kind={KIND.negative}
                    closeable
                  >
                    {() => errorMutate.message}
                  </Notification>
                  <SeparatorVertical $margin={8} />
                </>
              )
            }
            flightPurchase={flightPurchase}
            onSubmit={async (input, form) => {
              const result = await mutateAsync(input);
              onResolve(result);
              return result.data;
            }}
          />
        </>
      }
    />
  );
}
